"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.WarningIconTriangle = void 0;
var _react = _interopRequireDefault(require("react"));
const WarningIconTriangle = _ref => {
  let {
    width = '33',
    height = '32'
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: width,
    height: height,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M16.25 10.6562L10.0625 20.8125C10 20.9062 10 20.9688 10 21.0625C10 21.3125 10.1875 21.5 10.4375 21.5H22.5312C22.7812 21.5 23 21.3125 23 21.0625C23 20.9688 22.9688 20.9062 22.9062 20.8125L16.7188 10.6562C16.6875 10.5625 16.5938 10.5 16.5 10.5C16.375 10.5 16.3125 10.5625 16.25 10.6562ZM14.9688 9.875C15.2812 9.34375 15.875 9 16.5 9C17.0938 9 17.6875 9.34375 18 9.875L24.1875 20.0312C24.375 20.3438 24.5 20.6875 24.5 21.0625C24.5 22.125 23.625 23 22.5312 23H10.4375C9.375 23 8.5 22.125 8.5 21.0625C8.5 20.6875 8.59375 20.3438 8.78125 20.0312L14.9688 9.875ZM17.5 19.5C17.5 20.0625 17.0312 20.5 16.5 20.5C15.9375 20.5 15.5 20.0625 15.5 19.5C15.5 18.9688 15.9375 18.5 16.5 18.5C17.0312 18.5 17.5 18.9688 17.5 19.5ZM17.25 13.75V16.75C17.25 17.1875 16.9062 17.5 16.5 17.5C16.0625 17.5 15.75 17.1875 15.75 16.75V13.75C15.75 13.3438 16.0625 13 16.5 13C16.9062 13 17.25 13.3438 17.25 13.75Z",
    fill: "white"
  }));
};
exports.WarningIconTriangle = WarningIconTriangle;
const WarningIcon = () => /*#__PURE__*/_react.default.createElement("svg", {
  width: "64",
  height: "65",
  viewBox: "0 0 64 65",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/_react.default.createElement("path", {
  d: "M32 11.5C24.4062 11.5 17.5625 15.5312 13.8125 22C9.96875 28.5625 9.96875 36.5312 13.8125 43C17.5625 49.5625 24.4062 53.5 32 53.5C39.5 53.5 46.3438 49.5625 50.0938 43C53.9375 36.5312 53.9375 28.5625 50.0938 22C46.3438 15.5312 39.5 11.5 32 11.5ZM32 56.5C23.375 56.5 15.5 52 11.1875 44.5C6.875 37.0938 6.875 28 11.1875 20.5C15.5 13.0938 23.375 8.5 32 8.5C40.5312 8.5 48.4062 13.0938 52.7188 20.5C57.0312 28 57.0312 37.0938 52.7188 44.5C48.4062 52 40.5312 56.5 32 56.5ZM27.5 41.5H30.5V32.5H28.25C27.4062 32.5 26.75 31.8438 26.75 31C26.75 30.25 27.4062 29.5 28.25 29.5H32C32.75 29.5 33.5 30.25 33.5 31V41.5H36.5C37.25 41.5 38 42.25 38 43C38 43.8438 37.25 44.5 36.5 44.5H27.5C26.6562 44.5 26 43.8438 26 43C26 42.25 26.6562 41.5 27.5 41.5ZM32 25.75C30.6875 25.75 29.75 24.8125 29.75 23.5C29.75 22.2812 30.6875 21.25 32 21.25C33.2188 21.25 34.25 22.2812 34.25 23.5C34.25 24.8125 33.2188 25.75 32 25.75Z",
  fill: "#66788C"
}));
var _default = exports.default = WarningIcon;